import { IReduxState } from 'types/redux';

export const localeSelector = (state: IReduxState) => state.locale.lang;
